<template>
  <div v-if="isActive">
    <ks-calendar
      :ref="`ks-list-calendar-${_uid}`"
      :showDate="showDate"
      :mode="mode"
      @onNext="calendarEvents($event, 'next')"
      @onPrevious="calendarEvents($event, 'previous')"
      @onToday="calendarEvents($event, 'today')"
      @onMonth="calendarEvents($event, 'month')"
      @onClick="setSelected($event)"
      @onMouseLeave="setHover($event, false)"
      @onMouseOver="setHover($event, true)"
      v-slot="{date}"
    >
      <slot
        :row="calendarData[date.format('YYYY-MM-DD')] ? calendarData[date.format('YYYY-MM-DD')] : {}"
        :date="date" 
        :activeViewType="activeViewType"
      />
    </ks-calendar>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
export default {
  name: "ks-list-calendar",
  props:{
    dataSource: { type: String, required: true },
    showDate:   { type: Boolean, default: true },
    mode:       { type:String, default: 'month' }
  },
  computed: {
    dataProvider() {
      return this.$parent.dataProvider ? this.$parent.dataProvider : null;
    },
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    type() {
      return this.$parent.type ? this.$parent.type : null;
    },
    list(){
      return this.$parent.list;
    },
    activeViewType() {
      return this.$parent.activeViewType;
    },
    isActive(){
      return this.$parent.activeViewType == 'calendar';
    }
  },
  watch:{
    list: {
      handler() {
        this.loadCalendarData();
      },
      depp: true
    },
    isActive: function(val){
      if(val) this.$parent.activeViewComponent = this;
    }
  },
  methods: {
    loadCalendarData() {
      try {
        this.calendarData = {};
        if (this.dataSource) {
          let groupByDate = {};
          for (let row of this.list) {
            if (typeof row[this.dataSource] !== 'undefined' && row[this.dataSource] !== null && moment(row[this.dataSource]).isValid()) {
              let date = moment(row[this.dataSource]);
              if (typeof groupByDate[date.clone().format('YYYY-MM-DD')] === 'undefined') {
                groupByDate[date.clone().format('YYYY-MM-DD')] = {'data': [], '__hovered': false, '__selected': false};
              }
              groupByDate[date.clone().format('YYYY-MM-DD')].data.push({...row, '__date': date});
            }else{
              throw `${this.dataSource} not is valid date or not found in record`; 
            }
          }
          this.calendarData = groupByDate;
          return;
        }else{
          throw 'the prop datasource is required';
        }
      } catch (err) {
        console.log('KS-APP: ks-list-calendar', err);
      }
    },
    calendarEvents(event, name) {
      this.$emit('calendarEvent', {event: event, name: name})
    },
    setSelected(evt) {
      if (this.calendarData[evt.date.format('YYYY-MM-DD')]) {
        for (let key in this.calendarData) {
          if (this.calendarData[key].__selected) {
            Vue.set(this.calendarData[key], '__selected', false);
            break;
          }
        }
        Vue.set(this.calendarData[evt.date.format('YYYY-MM-DD')], '__selected', true);
      }
    },
    setHover(evt, value) {
      if (this.calendarData[evt.date.format('YYYY-MM-DD')]) {
        Vue.set(this.calendarData[evt.date.format('YYYY-MM-DD')], '__hovered', value);
      }
    },
    getComponentConfiguration(){
      return this.$refs[`ks-list-calendar-${this._uid}`].getComponentConfiguration();
    },
    setComponentConfiguration(config){
      this.$refs[`ks-list-calendar-${this._uid}`].setComponentConfiguration(config);
    }
  },
  mounted(){
    if(this.isActive){
      this.$parent.activeViewComponent = this;
    }
    this.loadCalendarData();
  },
  data() {
    return {
      calendarData : {}
    }
  }
}
</script>